import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const McdInvLedgerPymtList = ({ mcdInvId, pymtId }) => {
  const augRowsReq = useCallback(
    (rowsReq) => {
      if (mcdInvId) {
        rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('mcdInvId', mcdInvId));
      }

      if (pymtId) {
        rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('pymtId', pymtId));
      }
    },
    [mcdInvId, pymtId],
  );

  return <EntityList entity="MCD_INV_LEDGER_PYMT" augRowsReq={augRowsReq} />;
};
